import './ArtistModal.scss';

import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useArtistContext } from '../ArtistPageContext';

export default function SocialsModal({ show, handleClose, onSave }) {
  const { artist, setArtist } = useArtistContext();

  const [spotifyLink, setSpotifyLink] = useState('');
  const [deezerLink, setDeezerLink] = useState('');
  const [youtubeLink, setYoutubeLink] = useState('');
  const [instagramLink, setInstagramLink] = useState('');
  const [tiktokLink, setTiktokLink] = useState('');

  useEffect(() => {
    setSpotifyLink(artist.spotify_link);
    setDeezerLink(artist.deezer_link);
    setYoutubeLink(artist.youtube_link);
    setInstagramLink(artist.instagram_link);
    setTiktokLink(artist.tiktok_link);
  }, [artist, show]);

  const handleSave = async () => {
    const updatedData = {
      spotify_link: spotifyLink,
      deezer_link: deezerLink,
      youtube_link: youtubeLink,
      instagram_link: instagramLink,
      tiktok_link: tiktokLink
    };
    setArtist(prev => ({ ...prev, ...updatedData }));
    if (onSave) onSave(updatedData);
    handleClose();
  };

  return (
    <Modal className='__artist-modal' show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Add your social links</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-subtitle">
          Share your social links here.
        </div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Spotify</Form.Label>
            <Form.Control
              value={ spotifyLink }
              onChange={ (e) => setSpotifyLink(e.target.value) }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Deezer</Form.Label>
            <Form.Control
              value={ deezerLink }
              onChange={ (e) => setDeezerLink(e.target.value) }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Youtube</Form.Label>
            <Form.Control
              value={ youtubeLink }
              onChange={ (e) => setYoutubeLink(e.target.value) }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Instagram</Form.Label>
            <Form.Control
              value={ instagramLink }
              onChange={ (e) => setInstagramLink(e.target.value) }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>TikTok</Form.Label>
            <Form.Control
              value={ tiktokLink }
              onChange={ (e) => setTiktokLink(e.target.value) }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-primary" onClick={ handleSave }>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
